import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'
import { ButtonMui } from 'src/components/ButtonMui'

export const Container = styled.form`
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 1rem;
    gap: 1rem;
`

export const ContainerButton = styled.div`
    display: flex;
    align-items: center;
    justify-items: center;
    width: 100%;
    gap: 1rem;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;
`

export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.8rem !important;
    margin: 0 !important;
`

export const CustomTypography = styled.p`
    font-size: 16px;
`

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;

  p {
    font-size: 16px;
  }
`
